<template>
  <li
    class="tag-item"
    style="white-space: nowrap; overflow: hidden"
    :style="{ 'background-color': isError ? 'red' : '', color: isError ? 'white' : '' }"
  >
    <div style="display: flex; align-items: stretch">
      <div
        v-if="isDrag"
        class="my-handle"
        style="display: inline-block; padding: 3px 5px 3px 5px; cursor: move; margin-left: 4px"
      >
        <em class="fas fa-grip-vertical" />
      </div>
      <div class="ignore-elements" style="display: inline-block; padding: 0">
        <div
          ref="tagInput"
          style="white-space: normal"
          :style="{ 'border-left': !isDrag ? '0' : 'auto' }"
          class="tag"
          maxlength="5"
          :contenteditable="isEdit"
          @focus="editText = isEdit"
          @blur="onBlurInput()"
          @input="update"
          @keydown.enter.prevent="pressEnter"
          v-text="isEdit ? text : replaceTags(text)"
        ></div>
      </div>

      <div class="ignore-elements" style="display: inline-block">
        <em
          v-if="!editText"
          class="fas fa-remove"
          style="padding: 6px 5px 2px; margin-right: 4px; cursor: pointer"
          @click="$emit('onDelete')"
        />
        <em
          v-else
          class="fas fa-pencil-alt"
          style="padding: 6px 5px 2px; margin-right: 4px; cursor: pointer; color: white"
          @click="onBlurInput()"
        />
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { replaceTags } from '@/utils/tags'

export default {
  props: {
    value: { default: '', type: String },
    isEdit: { default: false, type: Boolean },
    max: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: 0
    },
    isDrag: {
      type: Boolean
    }
  },
  data: function () {
    return {
      text: this.value,
      editText: false,
      isError: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal && newVal != this.$refs.tagInput.innerText) {
        this.$refs.tagInput.innerText = this.value
      }
    }
  },
  methods: {
    replaceTags,
    pressEnter: function () {
      this.onBlurInput()
    },
    onBlurInput: function () {
      var vm = this
      if (!vm.isEdit) return
      if (vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText) == '') {
        vm.$emit('onDelete')
        return false
      } else {
        vm.$emit(
          'onChange',
          Object.assign(
            {},
            {
              tag: {
                // status: 'edit',
                text: vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText)
              },
              addTag: function () {
                vm.$refs.tagInput.innerText = vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText)

                vm.$emit('input', vm.noSpaceAndSpecial(vm.$refs.tagInput.innerText))
                vm.$emit('tags-changed')
                vm.editText = false
                vm.$refs.tagInput.blur()
              },
              error: function () {
                vm.isError = true
              }
            }
          )
        )
      }
    },
    update: function (event) {
      if (event.target.innerText.trim() == '') {
        return false
      }
      this.isError = false
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/TagItem.vue